import { ControlStatusEnum } from '../enums/control-status.enum';

export class ControlOrganizationLevelSeg {
    id: string;
    controlId: string;
    organizationLevelId: string;
    organizationLevelName?: string;
    segId: string;
    segName?: string;
    ownerUserId?: string;
    ownerName?: string;
    status: ControlStatusEnum;
    dateImplementationStart?: string;
    dateImplementationComplete?: string;
    targetImplementationStart?: string;
    targetImplementationEnd?: string;
    notes?: string;
    createdByUserId: string;
    dateCreated: Date;
    dateUpdated: Date;
    updatedByUserId: string;
    isDeleted: boolean;
    deletedDate?: Date;
    deletedByUserId?: string;
}
